import { Label, Input, Text } from "@avanadeits/vangogh";

type Props = {
  label: string;
  value: string;
};

export const StaticInputField = (props: Props) => {
  return (
    <>
      <Label>
        <Label.Inner>
          <Label.Header>
            <Label.HeaderMain>
              <Text>{props.label}</Text>
            </Label.HeaderMain>
          </Label.Header>
          <Label.Body>
            <Input value={props.value} disabled={true} />
          </Label.Body>
        </Label.Inner>
      </Label>
    </>
  );
};
